import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useToast } from '@hub-la/shadcn'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { GetWaitlistInput } from '../../../domain/dtos/waitlist'
import { QueryKey } from '../../../domain/enums/query-key'
import { GetWaitlist } from '../../../usecases/waitlist/get-waitlist'

export const useGetWaitlist = (input: GetWaitlistInput) => {
  const container = useContainer()
  const { toast } = useToast()
  const { t } = useTranslation()

  return useQuery(
    [QueryKey.getWaitlist, JSON.stringify(input)],
    ({ signal }) => {
      return new GetWaitlist(container.get(HttpClient)).execute(input, signal)
    },
    {
      retry: 3,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      onError: (error: Error) => toast({ description: t(error.message), variant: 'destructive' }),
    },
  )
}
